import { LocalStyles } from "@paperbits/common/styles";

export class ValidationSummaryModel {
    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
